export default "/_next/static/chunks/fonts/FontAwesome5_Solid-32267f3b4db33a7c85ee31d9b317c9e4.ttf";